import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";

import { loginWithGoogle } from "../../lib/api";
import { saveSession } from "../../lib/auth";
import type { SessionUser } from "../../lib/auth";
import { usePermissionsContext } from "../../data/permissions/permissionContext";

export const GoogleCallbackPage = () => {
  const navigate = useNavigate();
  const { setPermissions } = usePermissionsContext();
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) return;
    handledRef.current = true;

    const hash = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const idToken = hash.get("id_token");

    if (!idToken) {
      navigate("/login", { replace: true });
      return;
    }

    loginWithGoogle(idToken)
      .then((data) => {
        const user = data.user as SessionUser;
        saveSession({
          token: data.token.access_token,
          user,
          expiresIn: data.token.expires_in,
        });
        setPermissions(user.permissions ?? []);
        const redirectTo = sessionStorage.getItem("gg_redirect_after_login") || "/";
        sessionStorage.removeItem("gg_redirect_after_login");
        navigate(redirectTo, { replace: true });
      })
      .catch((err: unknown) => {
        Sentry.captureException(err, { tags: { flow: "google-oauth-callback" } });
        navigate("/login", { replace: true });
      });
  }, [navigate, setPermissions]);

  return null;
};
